import React from 'react';
export function Footer() {
  return <footer className="defer-paint w-full border-t border-line bg-canvas py-10" data-id="element-82" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-83" data-mp="3ggapns7ja73v">
        <p className="font-serif text-lg font-bold uppercase tracking-[0.3em] text-ink" data-id="element-84" data-mp="32nun0sijob3h">
          Yoga Kit <span className="text-accent" data-id="element-85" data-mp="36pfufycb7x6a">Pro™</span>
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-accent/40" aria-hidden="true" data-id="element-86" data-mp="36ppk1ktg02bg" />
        <p className="mt-6 font-sans text-xs leading-relaxed text-muted" data-id="element-87" data-mp="3ugbsveb9tqmi">
          © 2026 Yoga Kit Pro™ — Tutti i diritti riservati.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-sans text-[11px] leading-relaxed text-muted" data-id="element-88" data-mp="3lecaahklyehg">
          Biblioteca professionale per insegnanti di yoga · Accesso immediato ·
          Formato PDF · Garanzia 7 giorni · Nessun abbonamento
        </p>
      </div>
    </footer>;
}